import { Factory } from 'fishery';
import { Job } from '@trukt/types/Job';

import { accountFactory } from './accountFactory';
import { stopFactory } from './stopFactory';
import { contactFactory } from './contactFactory';
import { userFactory } from './userFactory';

export const jobFactory = Factory.define<Job>(({ sequence }) => ({
  classification: {
    id: '1',
    label: 'Transport',
    type: 'transport',
    isDefault: true,
  },
  id: sequence.toString(),
  guid: sequence.toString(),
  number: '189111',
  status: 'new',
  distance: 233,
  isDummy: false,
  dateCreated: '2022-08-26T22:23:42.294Z',
  dateUpdated: '2022-08-26T22:23:42.294Z',
  vendor: accountFactory.build(),
  dispatcher: userFactory.build(),
  stops: stopFactory.buildList(2),
  category: 'transport',
  type: 'transport',
  activeContracts: 5,
  caseLabelCount: 3,
  caseLabels: [],
  client: accountFactory.build(),
  referrer: accountFactory.build(),
  clientContact: contactFactory.build(),
  clientPayment: '',
  equipmentType: 'Open',
  inspectionType: 'standard',
  commodities: [],
  commodityCount: 4,
  grossProfit: '',
  grossProfitMargin: '',
  loadboards: [],
  orderGuid: '123',
  referenceNumber: '554433',
  salesperson: userFactory.build(),
  vendorPayment: '',
  dateVendorStarted: '2022-08-26T22:23:42.294Z',
  dateVendorCompleted: '2022-08-27T22:23:42.294Z',
  dateVerified: '2022-08-26T22:23:42.294Z',
  vendorContact: contactFactory.build(),
  vendorAgent: null,
  vendorCredit: '',
  bol: '',
  bolUrl: '',
  instructions: 'Please set job to ready as soon as possible.',
  loadType: 'full truck load',
  loadboardInstructions: '',
  ownerAccount: accountFactory.build(),
}));
